import { useMutation } from "@tanstack/react-query";

import { ApiClient } from "../api-client";

export const useRegisterBuyer = () => {
  return useMutation({
    mutationFn: async ({ buyerToken }: { buyerToken: string }) => {
      const response = await ApiClient.api.blikPurchaseControllerRegisterBuyer({
        buyerToken,
      });

      return response.data;
    },
  });
};
